const toggleBtn = document.querySelector('.js-hamburger');
const mobileMenu = document.querySelector('.js-mobile-menu');

if (toggleBtn && mobileMenu) {
	toggleBtn.addEventListener('click', () => {
		const { body } = document;
		toggleBtn.classList.toggle('active');
		mobileMenu.classList.toggle('active');

		body.classList.toggle('mobile-menu-opened');

		if (body.classList.contains('mobile-menu-opened')) {
			// eslint-disable-next-line no-undef
			disableBodyScroll(true, ['.js-mobile-menu']);
		} else {
			// eslint-disable-next-line no-undef
			disableBodyScroll(false, ['.js-mobile-menu']);
		}
	});
}
